import { render, staticRenderFns } from "./address-book.vue?vue&type=template&id=2272330a&"
import script from "./address-book.vue?vue&type=script&lang=js&"
export * from "./address-book.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports